<mat-label>Evidence Capture<span class="star">*</span></mat-label>

<app-file-field (fileUploaded)="onFileChange($event)"></app-file-field>

<a *ngIf="fileCtrl.value" [href]="fileCtrl.value" target="_blank"><span class="text-success">View Evidence</span></a>
